export enum JwtValidationErrors {
  InvalidToken = "Invalid token",
  TokenExpired = "Token expired",
}
